import { render, staticRenderFns } from "./Articulos.vue?vue&type=template&id=2746e2fb"
import script from "./Articulos.vue?vue&type=script&lang=js"
export * from "./Articulos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports